import { render, staticRenderFns } from "./kesim.vue?vue&type=template&id=cba277a0&scoped=true&"
import script from "./kesim.vue?vue&type=script&lang=js&"
export * from "./kesim.vue?vue&type=script&lang=js&"
import style0 from "./kesim.vue?vue&type=style&index=0&id=cba277a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba277a0",
  null
  
)

export default component.exports